import { memo, useCallback, useMemo } from 'react';

import { useCommandState } from '@air/cmdk';

import { SearchCommandGroup } from '~/components/SearchCommand/SearchCommandGroup';
import { SearchCommandSuggestionListItem } from '~/components/SearchCommand/SearchCommandSuggestionListItem';

export type SearchCommandSuggestionListProps = {
  onSelect: (suggestion: string) => void;
  suggestions?: string[];
};

export const SearchCommandSuggestionList = memo(({ suggestions, onSelect }: SearchCommandSuggestionListProps) => {
  const search = useCommandState((state) => state.search);

  const onSelectSearch = useCallback(() => {
    onSelect(search);
  }, [onSelect, search]);

  /**
   * Check if the search is not in the suggestions list
   */
  const shouldShowSearch = useMemo(() => {
    return !!search && !suggestions?.includes(search);
  }, [search, suggestions]);

  if (!suggestions?.length && !search) {
    return null;
  }

  return (
    <SearchCommandGroup heading={search ? undefined : 'Search suggestions'}>
      {shouldShowSearch && <SearchCommandSuggestionListItem suggestion={search} onSelect={onSelectSearch} />}

      {suggestions?.map((suggestion) => (
        <SearchCommandSuggestionListItem key={suggestion} suggestion={suggestion} onSelect={onSelect} />
      ))}
    </SearchCommandGroup>
  );
});

SearchCommandSuggestionList.displayName = 'SearchCommandSuggestionList';
